import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { UserDialogService } from '../../service/user-dialog.service';

export type UserDialogOptions = { okText?: string; cancelText?: string; hideCancel?: boolean }; // can also contain arbitrary translation parameters

@Component({
    selector: 'app-dialog-box',
    templateUrl: './dialog-box.component.html',
    styleUrls: ['./dialog-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DialogBoxComponent {
  constructor(private userDialogService: UserDialogService) {
    this.userDialogService.currentDialog.subscribe(data => this._showDialog(data));
  }

  show: boolean;
  message: string;
  param: {};
  cancelText: string;
  okText: string;
  hideCancel: boolean;

  private _showDialog(data: { message?: string; param?: UserDialogOptions }) {
    this.message = data && data.message ? data.message : '';
    this.param = data.param;
    this.okText = data.param && data.param.okText ? data.param.okText : 'OK_BTN';
    this.cancelText = data.param && data.param.cancelText ? data.param.cancelText : 'CANCEL_BTN';
    this.hideCancel = data.param && data.param.hideCancel;
    this.show = true;
  }

  cancel() {
    this.show = false;
    setTimeout(() => this.userDialogService.setDialogResult(false), 100);
  }

  ok() {
    this.show = false;
    this.userDialogService.setDialogResult(true);
  }
}
